<template>
  <el-form ref="quick-search" :model="{}" label-width="140px" v-if="outterForm">
    <el-form-item>
      <span slot="label">
        <span>搜索快投</span>

        <el-tooltip placement="top-start" content="快速投放到搜索流量，并可以主动添加关键词，设置人群探索">
          <i class="el-icon-info"></i>
        </el-tooltip>
      </span>
      <el-switch v-model="outterForm.quick_search" :active-value="1" :inactive-value="0"></el-switch>
    </el-form-item>

    <el-form-item v-if="outterForm.quick_search">
      <span slot="label">
        <span>搜索人群探索</span>
        <el-tooltip placement="top-start" content="系统将基于用户搜索行为探索定向人群以外的更多优质人群">
          <i class="el-icon-info"></i>
        </el-tooltip>
      </span>
      <el-switch v-model="outterForm.target_explore" :active-value="1" :inactive-value="0"></el-switch>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  props: {},
  computed: {
    formData() {
      return this.$store.getters['Kuaishou/currTaskParams']
    },
    outterForm: {
      get() {
        return this.formData.outterForm
      },
      set(v) {
        this.$store.commit('Kuaishou/UPDATE_OUT_PARAMS', v)
      }
    },
    innerForm: {
      get() {
        return this.formData.innerForm
      },
      set(v) {
        this.$store.commit('Kuaishou/UPDATE_INNER_PARAMS', v)
      }
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
<style lang="scss" scoped></style>
